import { Tooltip } from 'antd';
import React from 'react';

interface ToolTipWrapperProps {
  title: string;
  color?: string;
  placement?: 'top' | 'left' | 'right' | 'bottom';
  trigger?: 'hover' | 'click' | 'focus';
  children?: React.ReactNode;
}

const ToolTipWrapper: React.FC<ToolTipWrapperProps> = ({
  title,
  color,
  children,
  placement = 'top',
  trigger = 'hover',
}) => {
  return (
    <Tooltip
      title={title}
      color={color}
      placement={placement}
      trigger={trigger}
    >
      {children}
    </Tooltip>
  );
};

export default ToolTipWrapper;
